import {
  createSlice,
  Draft,
  PayloadAction,
  Slice,
} from '@reduxjs/toolkit';

type BasicCaseReducer<T> = {
  set(state: Draft<T>, action: PayloadAction<T>): T;
};
export default function createBasicSlice<N extends string, T>(
  name: N,
  initialState: T
): Slice<T, BasicCaseReducer<T>, N> {
  return createSlice({
    name,
    initialState,
    reducers: {
      set(_state, action: PayloadAction<T>) {
        return action.payload;
      },
    },
  });
}

type UpdateCaseReducer<T, P> = {
  update(state: Draft<T>, action: PayloadAction<P>): T;
};
export function createUpdateSlice<N extends string, T, P>(
  name: N,
  initialState: T,
  updateAction: (state: Draft<T>, payload: P) => T
): Slice<T, UpdateCaseReducer<T, P>, N> {
  return createSlice({
    name,
    initialState,
    reducers: {
      update(state, action: PayloadAction<P>) {
        return updateAction(state, action.payload);
      },
    },
  });
}
